import React from 'react';

import { clsxm } from '@/shared/lib';

interface ProgressBarProps {
  value: number;
  displayValue?: string | number;
  max?: number;
  height?: string;
  barBgColor?: string;
  trackBgColor?: string;
  showValue?: boolean;
  barClassName?: string;
  trackClassName?: string;
  valueLabelClassName?: string;
}
/**
 *
 * @param value: number; // Current value (percentage) of the progress bar
 * @param max?: number; // Optional maximum value, default is 100
 * @param barBgColor: string; // Tailwind class for the progress bar color
 * @param  trackBgColor: string; // Tailwind class for the track color
 * @param height?: string; // Optional height of the progress bar, default is 'h-4'
 * @param barClassName?: string; // Optional additional class for the progress bar
 * @param trackClassName?: string; // Optional additional class for the track
 * @param showValue?: boolean; // Option to show or hide the value text

 *
 */
const ProgressBar: React.FC<ProgressBarProps> = ({
  value,
  max = 100,
  height = 'h-14',
  barBgColor = 'bg-secondary-60',
  trackBgColor = 'bg-background-neutral-100',
  barClassName,
  trackClassName,
  valueLabelClassName,
  showValue = true,
  displayValue,
}) => {
  // Calculate width percentage
  const width = Math.min(100, (value / max) * 100);

  /***********styles conditions ***************************** */
  const trackStyle = clsxm(
    'w-full rounded-lg ',
    height,
    trackBgColor,
    barClassName
  );
  const barStyle = clsxm(
    'h-full rounded-lg flex justify-end items-center  overflow-hidden',
    barBgColor,
    trackClassName
  );
  const valueLabelStyle = clsxm(
    ' text-12 font-bold px-5 ',
    valueLabelClassName
  );
  /************************************************************ */

  return (
    <div className={trackStyle}>
      <div style={{ width: `${width}%` }} className={barStyle}>
        {showValue && (
          <span className={valueLabelStyle}>{displayValue || value}</span>
        )}
      </div>
    </div>
  );
};

export default ProgressBar;
